import { styled } from '@mui/system';
import { ReactNode } from 'react';

export type HeaderProps = {
  title?: string;
  left?: ReactNode;
  right?: ReactNode;
  variant?: 'primary';
};

const StyledHeader = styled('header')<{ variant?: 'primary' }>(
  ({ theme, variant }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding:
      variant === 'primary' ? 0 : `${theme.spacing(4)} ${theme.spacing(6)}`,
    borderBottom:
      variant === 'primary'
        ? ''
        : '1px solid var(--stroke-stroke-primary-color)',
  })
);

const StyledPageHeader = styled('h1')<{ variant?: 'primary' }>(
  ({ variant }) => ({
    fontWeight: 600,
    fontSize: variant === 'primary' ? 32 : 16,
    lineHeight: 1.5,
    margin: 0,
  })
);

export const Header = ({ title, variant, left, right }: HeaderProps) => {
  return (
    <StyledHeader variant={variant}>
      {left}
      <StyledPageHeader variant={variant}>{title}</StyledPageHeader>
      {right}
    </StyledHeader>
  );
};
